export default "__VITE_ASSET__5f53101f__"